import { render, staticRenderFns } from "./OnboardingOnfidoError.vue?vue&type=template&id=f10b9184&"
import script from "./OnboardingOnfidoError.vue?vue&type=script&lang=js&"
export * from "./OnboardingOnfidoError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports